<template>

  <el-dialog :title="titles"
             :visible.sync="dialogFormVisible"
             width="600px"
             append-to-body
             top="10px"
             @close="handleClose()"
             @open="open()">
    <div>
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="userForm">
        <el-form-item label="头像："
                      prop="icon_url">
          <el-upload :action="imgUploadUrl"
                     list-type="picture-card"
                     :on-remove="handleRemove"
                     :on-success="handleSuccess"
                     :file-list="fileList"
                     :limit="1"
                     v-if="fileList.length==0">
            <i class="el-icon-plus"></i>
          </el-upload>
          <img :src="fileList[0].url"
               v-if="fileList.length>0"
               style="width:100px;height:100px" />
          <div class="chooseAvatar">
            <div class="chooseRight">
              <div v-for="(item,index) in arr_random_avatar"
                   :key="index"
                   @click="chooseImg(item,index)"> <img :src="item"
                     :style="{'border': index==active?'1px solid #409EFF' :''}" /></div>
            </div>
            <div class="huan"
                 @click="handleCut()"> <img src="https://upload.kaoyanbox.net/0439303b6785a14e5b954356c350580e.png" />换一批 </div>
          </div>

          <!-- </div> -->
        </el-form-item>
        <el-form-item label="昵称"
                      prop="icon_url">
          <el-input v-model="userForm.nickname"
                    style="width:450px"
                    clearable></el-input>
          <img src="https://upload.kaoyanbox.net/0439303b6785a14e5b954356c350580e.png"
               style="width:14px;height:11px;marginLeft:5px;cursor: pointer;"
               @click="NameCut()" /> <span style="fontSize:12px; cursor: pointer;"
                @click="NameCut()">换一批</span>
        </el-form-item>
        <el-form-item label="身份"
                      prop="icon_url">
          <el-radio-group v-model="userForm.user_educate_type">
            <el-radio :label="2">学长</el-radio>
            <el-radio :label="1">学生</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年份">
          <el-select v-model="userForm.educate_year"
                     filterable
                     clearable
                     collapse-tags
                     placeholder="请选择"
                     style="width:450px">
            <el-option v-for="(item, index) in  filter.year"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院校">
          <el-select v-model="userForm.college_code"
                     filterable
                     clearable
                     collapse-tags
                     placeholder="请选择"
                     style="width: 450px"
                     @change="collegeChange">
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业">
          <el-select v-model="userForm.major_code"
                     filterable
                     clearable
                     collapse-tags
                     placeholder="请选择"
                     style="width: 450px"
                     @change="majorChange">
            <el-option v-for="(item, index) in majorList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学院">
          <el-select v-model="userForm.academy_code"
                     filterable
                     clearable
                     collapse-tags
                     placeholder="请选择"
                     style="width: 450px"
                     @change="academyChange">
            <el-option v-for="(item, index) in academyList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
              <span>{{ `${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目：">
          <el-select v-model="userForm.subject_codes"
                     multiple
                     clearable
                     placeholder="请选择"
                     style="width: 450px"
                     @change="handleSubject">
            <el-option v-for="(item, index) in subjectsList"
                       :key="index"
                       :label="item.subject_name"
                       :value="item.subject_code">
              <span>{{
                    `（${item.subject_code}）${item.subject_name}`
                  }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="submit">
        <div class="cancle"
             @click="handleClose()">取消</div>
        <div class="confirm"
             @click="submit()">确定</div>
      </div>

    </div>

  </el-dialog>

</template>
<script>
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
  majorList,
} from '@/api/common'
import {
  createUserIdentity,
  putUserIdentity,
  generateRandomAvatar,
} from '@/api/senior'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: () => {
        return ''
      },
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    topic_college_code: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_college_name: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_major_code: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_major_name: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_subject_code: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_subject_name: {
      type: String,
      default: () => {
        return ''
      },
    },
    fasterCreate: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      active: null,
      titles: '新建虚拟用户',
      dialogFormVisible: this.isVisible,
      userForm: {
        subject_codes: [],
        user_educate_type: 2,
        nickname: '',
        educate_year: '2025',
        academy_code: '',
        college_code: '',
        major_code: '',
      },
      arr_random_avatar: [],
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      fileList: [],
      majorList: [],
      academyList: [],
      subjectsList: [],
      filter: {
        year: [
          {
            label: '2026年',
            value: '2026',
          },
          {
            label: '2025年',
            value: '2025',
          },
          {
            label: '2024年',
            value: '2024',
          },
          {
            label: '2023年',
            value: '2023',
          },
          {
            label: '2022年',
            value: '2022',
          },
          {
            label: '2021年',
            value: '2021',
          },
          {
            label: '2020年',
            value: '2020',
          },
        ],
      },
      virtualName: [
        // 两字/三字短语
        '枕书眠',
        '研墨生',
        '读山人',
        '听松研',
        '扫叶斋',
        '焚香读',
        '抱卷子',
        '观云研',
        '踏雪读',
        '拾萤录',
        '煮茶研',
        '推窗读',
        '种竹君',
        '临帖生',
        '抚琴研',
        '栽梧人',
        '照夜书',
        '挹清研',
        '倚砚客',
        '啸月读',
        '拥书郎',
        '看山研',
        '洗砚生',
        '吟风子',
        '藏书癖',
        '点灯读',
        '耕心田',
        '驻云研',
        '折梅读',
        '拭尘卷',
        '听雨研',
        '拾阶读',
        '拥雪斋',
        '研古意',
        '问樵子',
        '抱拙研',
        '澄怀读',
        '寻幽客',
        '研素心',
        '卧丘读',
        '拾光研',
        '静观书',
        '抚卷生',
        '研溪声',
        '望岳读',
        '研竹影',
        '拥书坐',
        '研秋声',
        '读夕照',
        '研松风',
        // 四字短语
        '一砚春深',
        '半窗灯火',
        '书灯夜雨',
        '砚池生烟',
        '松间读易',
        '竹里研经',
        '月下抄书',
        '风前校字',
        '雪夜拥卷',
        '云外听书',
        '灯下观史',
        '窗前种字',
        '砚边拾句',
        '墨里藏山',
        '纸上行舟',
        '笔底生春',
        '书田耕月',
        '卷中寻路',
        '研海浮槎',
        '字里停云',
        '读破千峰',
        '写尽孤灯',
        '心游万仞',
        '手抄三更',
        '墨洗尘襟',
        '书伴寒宵',
        '砚暖霜晨',
        '字种心田',
        '灯照归途',
        '卷藏天地',
        '笔耕不息',
        '读向青崖',
        '写就初心',
        '墨点星河',
        '书叠云梯',
        '研透微光',
        '字如初雪',
        '读在深秋',
        '写满春风',
        '砚守孤光',
        '书渡迷津',
        '笔引前路',
        '墨染年华',
        '卷启新程',
        '灯暖研途',
        '字寄山河',
        '读见真知',
        '写答岁月',
        '砚承薪火',
        '书照来者',
      ],
      isFaster: false,
      subjectCode: [],
      subjectName: '',
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
    title(val) {
      this.titles = val
    },
    // 是否为快速创建
    fasterCreate(val) {},
    topic_college_code(val) {
      if (val) {
        this.userForm.college_code = val
        this.userForm.college_name = this.topic_college_name
      }
    },
    topic_major_code(val) {
      if (val) {
        this.userForm.major_code = val + ''
        this.userForm.major_name = this.topic_major_name
        this.getMajorAll()
        this.getAcademy(this.userForm.college_code, this.userForm.major_code)
      }
    },
    topic_subject_code(val) {
      if (val) {
        this.userForm.subject_codes.push(val + '')
        this.userForm.subject_names = this.topic_subject_name
        this.getSubjectsByMajorCode(
          this.userForm.college_code,
          this.userForm.major_code
        )

        this.subjectCode.push(val + '')
        this.subjectName = this.topic_subject_name
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
      this.userForm.college_code = ''
      this.userForm.college_name = ''
      this.userForm.major_code = ''
      this.userForm.major_name = ''
      this.userForm.academy_code = ''
      this.userForm.academy_name = ''
      this.userForm.subject_codes = []
      this.userForm.subject_names = ''
      this.userForm.educate_year = ''
      this.userForm.nickname = ''
      this.userForm.user_educate_type = 2
      this.majorList = []
      this.academyList = []
      this.subjectsList = []
      this.detail = {}
      this.fileList = []
    },
    open() {
      this.$set(this.userForm, 'educate_year', '2025')
      this.getAvatar()
      this.NameCut()
      if (this.title == '编辑虚拟用户' && this.detail) {
        this.userForm.nickname = this.detail.nickname
        this.userForm.user_educate_type = this.detail.user_educate_type
        this.userForm.educate_year = this.detail.educate_year
        this.userForm.college_code = this.detail.college_code
        this.userForm.college_name = this.detail.college_name
        this.userForm.major_code = this.detail.major_code + ''
        this.userForm.major_name = this.detail.major_name
        this.userForm.academy_code = this.detail.academy_code
        this.userForm.academy_name = this.detail.academy_name
        this.detail.subject_codes.split(',').map((item) => {
          this.userForm.subject_codes.push(item)
        })
        this.userForm.subject_names = this.detail.subject_names
        this.fileList.push({
          url: this.detail.avatar,
        })
        this.getMajor(this.userForm.college_code)
        this.getAcademy(this.userForm.college_code, this.userForm.major_code)
        this.getSubjectsByMajorCode(
          this.userForm.college_code,
          this.userForm.major_code
        )
      }
    },
    handleCut() {
      this.getAvatar()
    },
    NameCut() {
      const randomIndex = Math.floor(Math.random() * this.virtualName.length)
      // 根据随机索引获取图片路径
      this.userForm.nickname = this.virtualName[randomIndex]
    },
    chooseImg(item, index) {
      this.active = index
      this.fileList = []
      this.fileList.push({
        url: item,
      })
    },
    getAvatar() {
      generateRandomAvatar().then((res) => {
        this.arr_random_avatar = res.arr_random_avatar
        // if (this.fasterCreate) {
        this.fileList.push({
          url: res.arr_random_avatar[0],
        })
        // }
      })
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          return item.response.data
        } else {
          return item
        }
      })
    },
    handleRemove() {},
    handleBeforeUpload() {},
    formateSenior() {
      let arr = []
      this.userForm.subject_codes.map((item) => {
        this.subjectsList.map((v) => {
          if (item == v.subject_code) {
            arr.push(v.subject_name)
          }
        })
      })
      this.userForm.subject_codes = this.userForm.subject_codes.join(',')
      this.userForm.subject_names = arr.join(',')
    },
    collegeChange(e) {
      this.userForm.major_code = ''
      this.userForm.major_name = ''
      this.userForm.academy_code = ''
      this.userForm.academy_name = ''
      this.userForm.subject_codes = ''
      this.userForm.subject_names = ''
      this.userForm.college_name = this.$store.state.collegeList.find(
        (item) => {
          return item.code === e //筛选出匹配数据
        }
      ).name
      this.getMajor(this.userForm.college_code)
    },
    majorChange(e) {
      this.userForm.subject_codes = ''
      this.userForm.subject_names = ''
      this.userForm.academy_code = ''
      this.userForm.academy_name = ''
      this.userForm.major_name = this.majorList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
      this.getAcademy(this.userForm.college_code, this.userForm.major_code)
      this.getSubjectsByMajorCode(
        this.userForm.college_code,
        this.userForm.major_code
      )
    },
    academyChange(e) {
      console.log('e', e)
      this.userForm.subject_codes = ''
      this.userForm.subject_names = ''
      this.userForm.academy_name = this.academyList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
      console.log('  this.userForm.academy_name', this.userForm.academy_name)
    },
    handleSubject() {
      // this.formateSenior()
    },
    //如果有院校添加筛选
    getMajor(college_code) {
      collegeMajorList({
        college_code: college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list || []
      })
    },
    //如果没有院校获取所有专业
    getMajorAll() {
      let data = {
        combine: 0,
        level: 3,
        isPaging: 0,
      }
      majorList(data).then((res) => {
        this.majorList = res.list || []
        this.getSubjectsByMajorCode(
          this.userForm.college_code,
          this.userForm.major_code
        )
      })
    },
    //录取学院
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || []
        this.userForm.academy_code = this.academyList[0].code
        this.userForm.academy_name = this.academyList[0].name
      })
    },
    getSubjectsByMajorCode(college_code, major_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }
      majorSubjectList(query).then((res) => {
        this.subjectsList = res.list || []
      })
    },
    submit() {
      if (this.userForm.educate_year == '') {
        this.$message.error('请选择年份')
        return
      }
      if (this.userForm.college_code == '') {
        this.$message.error('请选择院校')
        return
      }

      if (this.userForm.major_code == '') {
        this.$message.error('请选择专业')
        return
      }
      if (this.userForm.academy_code == '') {
        this.$message.error('请选择学院')
        return
      }
      if (this.userForm.subject_codes.length == 0) {
        this.$message.error('请选择科目')
        return
      }

      this.formateSenior()
      this.userForm.avatar = this.fileList[0].url
      if (this.title == '新建虚拟用户') {
        createUserIdentity(this.userForm).then((res) => {
          if (res.message == '') {
            this.handleClose()
            this.$message.success('创建成功')
          } else {
            this.userForm.subject_codes = this.subjectCode
            this.userForm.subject_names = this.subjectName
          }
        })
      } else if (this.title == '编辑虚拟用户') {
        this.userForm.id = this.detail.id
        putUserIdentity(this.userForm).then((res) => {
          this.handleClose()
          this.$message.success('修改成功')
        })
      }
    },
  },
}
</script>
<style scoped lang="less">
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
::v-deep .el-upload--picture-card {
  width: 100px;
  height: 100px;
}
.search-wrap {
  position: relative;
  display: flex;
  flex-flow: column;

  .chooseAvatar {
    position: absolute;
    right: -330px;
    top: 0px;
    display: flex;
    align-items: center;
    .chooseRight {
      display: flex;
      flex-wrap: wrap;
      // margin-left: 10px;
      width: 270px;
      height: 80px;
      img {
        margin-right: 10px;
        width: 42px;
        height: 42px;
      }
    }
    .huan {
      cursor: pointer;
      display: flex;
      align-items: center;
      font-size: 12px;
      img {
        margin-top: -2px;
        width: 14px;
        height: 11px;
      }
    }
  }
}
.submit {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  .cancle {
    margin-right: 10px;
    text-align: center;
    width: 56px;
    height: 36px;
    font-size: 14px;
    color: #909399;
    line-height: 36px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdfe6;
  }
  .confirm {
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    width: 56px;
    height: 36px;
    line-height: 36px;
    background: #409eff;
    border-radius: 4px 4px 4px 4px;
  }
}
</style>